import type { Reward } from '../../../components/loyalty/data/types';

export const FETCH_REWARDS_REQUEST = 'loyalty/rewards/FETCH_REWARDS_REQUEST';
export const FETCH_REWARDS_SUCCESS = 'loyalty/rewards/FETCH_REWARDS_SUCCESS';
export const FETCH_REWARDS_FAILURE = 'loyalty/rewards/FETCH_REWARDS_FAILURE';

export const FETCH_REWARD_DETAIL_REQUEST = 'loyalty/rewards/FETCH_REWARD_DETAIL_REQUEST';
export const FETCH_REWARD_DETAIL_SUCCESS = 'loyalty/rewards/FETCH_REWARD_DETAIL_SUCCESS';
export const FETCH_REWARD_DETAIL_FAILURE = 'loyalty/rewards/FETCH_REWARD_DETAIL_FAILURE';

export const UPDATE_REWARD_REQUEST = 'loyalty/rewards/UPDATE_REWARD_REQUEST';
export const UPDATE_REWARD_SUCCESS = 'loyalty/rewards/UPDATE_REWARD_SUCCESS';
export const UPDATE_REWARD_FAILURE = 'loyalty/rewards/UPDATE_REWARD_FAILURE';

export const CLEAR_REWARDS_ERROR = 'loyalty/rewards/CLEAR_REWARDS_ERROR';

export interface LoyaltyRewardsState {
  rewards: Reward[];
  loading: boolean;
  saving: boolean;
  error: string | null;
  rewardsLastFetchedAt: string | null;
}
